module.exports = __webpack_public_path__ + "img/ceshi1.2efd20c1.png";